import Utilitiesjs from '../utilites';
import Ajaxjs from '../ajax';
import regeneratorRuntime from "regenerator-runtime";

export default class EventsReportjs {

    constructor() {
        this.ajaxjs = new Ajaxjs;
        this.utilsjs = new Utilitiesjs
        this.maxPagination = 10;
        this.localPageSize = 10;
    }
    initTable(tableId, data) {
        let that = this;
        that.tableId = tableId;

        this.filter = {
            user: document.getElementById('user').value,
            hash: document.getElementById('hash').value,
            pageSize: document.getElementById('pageSize').value,
        };

        //init table data
        that.renderTableData(data)

        that.initCurrentPageFilter();
    }

    searchFilterResult() {
        let that = this;
        that.setFilterParam();
        that.search(1);
    }

    setFilterParam() {
        let that = this;
        const { trim } = this.utilsjs;
        document.querySelectorAll("#reportFilterForm input,#reportFilterForm select").forEach(ele => {
            that.filter[ele.name] = trim(ele.value);
        })
    }

    getFilterParamUrl() {
        const { filter } = this;
        const paramUrl = Object.keys(filter).map(key => {
            return `${key}=${filter[key]}`;
        })
        return "&" + paramUrl.join("&");
    }

    async search(page = 1) {
        const that = this;

        if (that.isReloadData()) {
            page = 1;
            that.setFilterParam();
        }


        let url = `${window.location.protocol}//${window.location.host}/Reports/EventsPaging?page=${page}` + that.getFilterParamUrl();

        const response = await fetch(url);
        const result = await response.json();

        if (!result) {
            return;
        }
        that.renderTableData(result)
    }

    renderTableData(data) {
        const that = this;
        that.currentPageData = data.Records;
        that.renderList(data.Records);
        that.renderPagination(data.CurrentPageNumber, data.TotalPageCount, "cscpjs.default.eventsReportjs.search", "tablePagination", true);


        that.currentPageFilter();
    }

    renderList(data) {
        const that = this;

        let arrHtml = [];

        if (data) {
            arrHtml = data.map(item => `
                <tr>
                    <td class="column-1">${item.EventName}</td>
                    <td class="column-2">${item.FirstName + " " + item.LastName}</td>
                    <td class="column-3">${item.CompanyHospital || ""}</td>
                    <td class="column-4">${item.RegistrationType || ""}</td>
                </tr>`
            );
        }

        document.querySelector(`#${that.tableId} tbody`).innerHTML = arrHtml.join("");
        window.scrollTo(0, 0);
    }

    renderPagination(currentPage, totalPage, clickEvent, containerEleId, isServer) {
        const that = this;

        let paginationHtml = "";

        if (totalPage > 0) {
            const maxPagination = that.maxPagination;

            let paginations = [];
            const startPagination = that.getStartPagination(currentPage, maxPagination, totalPage);
            const endPagination = startPagination + maxPagination - 1;
            if (isServer) {
                for (let i = startPagination; i <= endPagination && i <= totalPage; i++) {
                    let j = i === 1 ? 1 : ((i - 1) * 50) + 1;
                    paginations.push(
                        `<li class="${i === currentPage ? "active" : ""}" data-page="${i}">
                    <a ${i !== currentPage ? "onclick=\"" + clickEvent + "(" + i + ")\"" : ""}><i>${j}-${j+49}</i></a>
                </li>`
                    );
                }
            } else {
                for (let i = startPagination; i <= endPagination && i <= totalPage; i++) {
                    paginations.push(
                        `<li class="${i === currentPage ? "active" : ""}" data-page="${i}">
                    <a ${i !== currentPage ? "onclick=\"" + clickEvent + "(" + i + ")\"" : ""}><i>${i}</i></a>
                </li>`
                    );
                }
            }
            

            paginationHtml = `
                <li>
                    <a  ${currentPage !== startPagination ? "onclick=\"" + clickEvent + "(" + (currentPage - 1) + ")\"" : "style=\"display:none\""}>
                        <i><</i>
                    </a>
                </li>
                ${paginations.join("")}
                <li>
                    <a ${totalPage !== currentPage ? "onclick=\"" + clickEvent + "(" + (currentPage + 1) + ")\"" : "style=\"display:none\""}>
                        <i>></i>
                    </a>
                </li>`;
        }

        document.getElementById(containerEleId).innerHTML = paginationHtml;

    }
    getStartPagination(currentPage, maxPagination, totalPage) {
        let startPagination = currentPage - maxPagination / 2;
        startPagination = startPagination <= 0 ? 1 : startPagination;

        if (totalPage - startPagination < maxPagination - 1) {
            startPagination = totalPage - maxPagination + 1;
        }

        startPagination = startPagination <= 0 ? 1 : startPagination;
        return startPagination;
    }

    report() {
        const that = this;
        that.setFilterParam();//The exported filter condition is the current form value
        location.href = "/Reports/EventAttendee?" + that.getFilterParamUrl().substring(1);
    }


    //Filter the currently displayed data without requesting the server. init
    initCurrentPageFilter() {
        const that = this;

        const reportFilterForm = document.querySelector("#reportFilterForm");

        if (!reportFilterForm) {
            return;
        }

        //input
        reportFilterForm.querySelectorAll("input").forEach(ele => {
            that.filter[ele.name] = "";
            ele.oninput = function () {
                that.currentPageFilter();
            };
        })

        //select
        reportFilterForm.querySelectorAll("select").forEach(ele => {
            that.filter[ele.name] = "";
            ele.onchange = function () {
                that.currentPageFilter();
            };
        })


    }

    //Filter the currently displayed data without requesting the server
    currentPageFilter(page = 1) {
        const that = this;
        let { currentPageData } = that;
        const { trim } = that.utilsjs;

        let localFilters = [];
        document.querySelectorAll("#reportFilterForm input,#reportFilterForm select").forEach(ele => {
            localFilters.push({ name: ele.name, value: trim(ele.value), type: ele.type });
        })

        const currentPageDispalyData = currentPageData.filter(item => {
            const itemKeys = Object.keys(item);
            for (let i = 0; i < localFilters.length; i++) {
                const filter = localFilters[i];
                const currentKey = itemKeys.find(itemKey => itemKey.toLowerCase() === filter.name.toLowerCase());
                if (currentKey) {
                    switch (filter.type) {
                        case "text":
                            if (filter.value && !(item[currentKey].toLowerCase().includes(filter.value.toLowerCase()))) {
                                return false;
                            }; break;
                        case "select-one":
                            if (filter.value && !(item[currentKey].toLowerCase()===filter.value.toLowerCase())) {
                                return false;
                            }; break;
                    }
                }
            }
            return true;
        });



        that.renderList(currentPageDispalyData.slice((page - 1) * 10, page * 10));

        that.renderPagination(page, Math.ceil(currentPageDispalyData.length / that.localPageSize), "cscpjs.default.eventsReportjs.currentPageFilter", "tableLocalPagination");
    }


    // If the filter condition changes, click on the page number and reload the data from the first page
    isReloadData() {
        const that = this;
        const { filter } = that;
        const { trim } = that.utilsjs;

        let currentFilter = {};
        document.querySelectorAll("#reportFilterForm input,#reportFilterForm select").forEach(ele => {
            currentFilter[ele.name] = trim(ele.value);
        })

        const filterKeys = Object.keys(currentFilter);

        for (let i = 0; i < filterKeys.length; i++) {
            const key = filterKeys[i];
            if ((!filter[key] || !currentFilter[key]) && filter[key] !== currentFilter[key]) {
                return true;
            }
        }
        return false;
    }

}





// WEBPACK FOOTER //
// ./Scripts/es6/Controllers/eventsReport.js